import { format } from 'date-fns';
import { useCallback, useContext, useMemo } from 'react';
import { DateContext } from '../../Core/Contexts/DateContext';
import { LocationContext } from '../../Core/Contexts/LocationContext';
import {
	useUpdateEntries,
} from '../../Core/Hooks/EntryHooks';
import { useGetPlanableOrders } from '../../Core/Hooks/OrderBookHooks';
import { useGetLocation } from '../../Core/Hooks/LocationHooks';
import { Props } from './PlannerPageTable';

type AdditionalProps = {
	isFetching: boolean;
	refresh: () => Promise<void>;
	handleOrderClick: () => void;
};

export const usePlannerPageTableData = (): Props & AdditionalProps => {
	const [selectedDate] = useContext(DateContext);
	const [selectedLocation] = useContext(LocationContext);

	const {
		data: currentLocation,
		isLoading: isLocationLoading,
		isFetching: isLocationFetching,
		refetch: refetchLocation,
	} = useGetLocation(selectedLocation);

	const {
		data: orders,
		isLoading: areStoreOrdersLoading,
		isFetching: areStoreOrdersFetching,
		refetch: refetchStoreOrders,
	} = useGetPlanableOrders();

	const isLoading = useMemo(
		() => isLocationLoading || areStoreOrdersLoading,
		[areStoreOrdersLoading, isLocationLoading]
	);
	const isFetching = useMemo(
		() => isLocationFetching || areStoreOrdersFetching,
		[areStoreOrdersFetching, isLocationFetching]
	);

	const refresh = useCallback(() => {
		return (
			Promise.all([refetchLocation(), refetchStoreOrders()])
				// We want to return void
				.then(() => {
				})
		);
	}, [refetchStoreOrders, refetchLocation]);

	const handleOrderClick = useCallback(() => {}, []);

	return {
		currentLocation,
		orders,
		isLoading,
		isFetching,
		refresh,
		handleOrderClick
	};
};
